module.exports = __webpack_public_path__ + "img/grass-texture.8d2335c3.png";